import React from 'react';
import { MDBTable, MDBTableBody, MDBTableHead, MDBContainer, MDBRow, MDBCol, MDBCard } from 'mdbreact';

const parlourOutlet = () => {
  return (
      <div>
          <section className=" my-5">
            <br                                     />
          </section>
          <section>
              <MDBContainer className="z-depth-3 p-3">
                  <h1>Parlour outlets</h1>
              </MDBContainer>
            
          <MDBContainer className="my-5" md="8">
              <MDBCard>
              <MDBRow>
                  <MDBCol md="12" sm="12">
                  <MDBTable bordered responsive >
      <MDBTableHead>
        <tr>
          <th>Name </th>
          <th>Address </th>
          <th>Contact No </th>
          <th>Location </th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
          <td>VISAKHA DAIRY PARLOUR </td>
          <td> VISAKHA DAIRY, NEAR AKKIREDDYPALEM, VISAKHAPATNAM- 530012 </td>
          <td>0891-2517230 </td>
          <td> AKKIREDDYPALEM </td>
        </tr>
        <tr>
          <td>VISAKHA DAIRY PARLOUR </td>
          <td>D.NO.47-3-13 5TH LANE, DWARAKANAGAR, VISAKHAPATNAM </td>
          <td> 	9949897245 </td>
          <td>DWARAKANAGAR</td>
          
        </tr>
        <tr>
          <td>VISAKHA DAIRY PARLOUR </td>
          <td>D.NO.14-35-1, MAHARANIPETA, NEAR COLLECTOR OFFICE, VISAKHAPATNAM</td>
          <td> 9963553772 </td>
          <td>MAHARANIPETA</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
  
                  </MDBCol>
              </MDBRow>
          
              </MDBCard>
        </MDBContainer>
      </section>

      </div>
);
}

export default parlourOutlet;